import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Icon from "./Icon";
import ThemeContext from "../utils/theme";

export default function Checkbox({
  label,
  checked = false,
  onChecked,
  className = "",
  disabled = false,
  ...restProps
}) {
  const checkboxClasses = classnames("checkbox", className);
  const { colorInvertedPrimary } = React.useContext(ThemeContext);

  return (
    <label className={checkboxClasses} onKeyUp={handleKeyUp} {...restProps}>
      <input
        disabled={disabled}
        className="sr-only"
        type="checkbox"
        defaultChecked={checked}
        onChange={handleCheck}
        tabIndex="-1"
      />

      <span role="checkbox" aria-checked={checked} aria-disabled={disabled}>
        {checked && <Icon symbol="checkmark" color={colorInvertedPrimary} />}
      </span>

      {label}
    </label>
  );

  function handleKeyUp(e) {
    if (e.keyCode === 32) {
      handleCheck();
    }
  }

  function handleCheck(e) {
    !disabled && onChecked && onChecked(!checked);
  }
}

Checkbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  checked: PropTypes.bool,
  onChecked: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};
